export const SCHEDULE_SYSTEM = `You are an expert Construction Scheduler and Project Manager using Primavera P6.
Analyze the provided schedule activities. I have provided ID, Name, Status, Dates, Float, Resources, Codes, and Predecessors where available.

Identify:
1. Critical Path Risks (Negative/Low Float).
2. Trade Stacking (Multiple similar resources in same timeframe).
3. Logic Gaps (Missing predecessors on started work, etc).
4. Out of Sequence progress.

Provide a concise "Field Insights" summary for a Site Superintendent.

CRITICAL INSTRUCTION:
Start any line mentioning a specific activity with its ID in brackets: [A1020].`;

export const REPOSITORY_SYSTEM = `You are an expert Construction Scheduler.
Based on the field updates/notes, identify which activities in the schedule need to be updated.
Look for Start Dates, Finish Dates, and % Complete updates.
Return a helpful analysis of what changes should be made in P6.

IMPORTANT FORMATTING RULE:
When you mention an activity that correlates to the field notes, you MUST wrap its Activity ID in brackets exactly like this: [A1020].`;

export const NARRATIVE_TASK = `Provide an email body summarizing the schedule update from the attached pdf files. Review last week's schedule and compare to this week's as able. Stay under 500 words total (slips about 150, finals about 100, earned value about 60, next week and the focus item about 120, intro and close about 50). Use at most about 6 bullets in any list.
1. the significant date changes, more than one week from the prior update, and
2. focus on the final activities, such as mechanical completion or final cleaning and the current date and if changed, what the previous update or baseline date is.
3. If there is earned value reports, calculate the total earned this week compared to last week. State the current percent complete and if you can determine, whether it is ahead or behind of the planned earned value.
4. Summarize the next week's activities, and what is the most critical item for the team to focus on.`;

export const NARRATIVE_SYSTEM = `You are a professional construction project controls analyst.
Generate a well-structured, professional narrative discussing status, risks, and updates according to the audience and scope.
Use markdown formatting (headings, lists, bold). Make it easy to read.
If writing for a field foreman, focus on immediate actions, blockers, and logistics.
If writing for a Project Manager, focus on critical path, resources, and short-term schedule risks.
If writing for an Executive Stakeholder, focus on high-level milestones, major risks, and overall project health.`;

export function scheduleUserPrompt(taskListString) {
	return `Activities:\n${taskListString}`;
}

export function repositoryUserPrompt(notesContext, taskListString) {
	return `Field updates/notes:\n${notesContext}\n\nSchedule Activities:\n${taskListString}`;
}

export function narrativeUserPrompt({ scope, targetAudience, templateNotes, taskListString }) {
	let templateSection = '';
	if (templateNotes && templateNotes.length) {
		templateSection = `Please carefully review the following historical field notes and formatting as a stylistic template for the narrative:\n\n${templateNotes.join('\n\n')}\n\n`;
	}
	return `Scope of Analysis requested by user:
"${scope}"

${templateSection}Target Audience (if not superseded by template priorities): ${targetAudience}

Current Schedule Data:
${taskListString}`;
}
